.progressBar {
  margin-top: 16px;
}
